

<template>
  <div class="categoryIn">
    <div class="nav">
      <div class="navInner">
        <!-- <img @click="$router.back()" src="@/assets/img/left-arrow.svg" alt="" /> -->
        <div @click="$router.back()" class="mask-image"></div>
        <span class="title">{{ catName }}</span>
      </div>
    </div>
    <ProductList
      :products="products"
      class="wrapProductList"
      :fetching="fetching"
      :error="error"
      :endList="endList"
      :page="page"
      :pageSize="pageSize"
      @scrollEnd="getCategoryProduct"
    />
    <DefaultDisplayStage :error="error" :nodata="nodata" />
    <ProductModal />
  </div>
</template>

<script>
import ProductList from "./ProductList";
import { GET } from "@/utils/http";
import DefaultDisplayStage from "@/components/DefaultDisplayStage";
import ProductModal from "./ProductModal";

export default {
  props: { catName: String, catId: String },
  components: {
    ProductList,
    DefaultDisplayStage,
    ProductModal,
  },
  data() {
    return {
      products: [],
      fetching: false,
      error: false,
      endList: false,
      page: 1,
      pageSize: 10,
    };
  },
  computed: {
    nodata() {
      return !this.fetching && this.products.length <= 0 && !this.error;
    },
  },
  methods: {
    async getCategoryProduct() {
      try {
        this.fetching = true;

        const shopId = this.$isSeller ? this.$myShop.id : this.$sellerShop.id;
        const { status, body } = await GET(
          `/api/shops/${shopId}/products?page=${this.page}&limit=${this.pageSize}&query=&categoryIds=${this.catId}`
        );

        if (status !== 200) {
          throw "not ok";
        }

        this.products.push(...body.data);

        if (this.page >= body.lastPage) {
          this.endList = true;
        } else {
          this.page++;
        }
      } catch (err) {
        this.error = true;
      } finally {
        this.fetching = false;
      }
    },
  },
  mounted() {
    this.getCategoryProduct();
  },
};
</script>
<style lang="scss" scoped>
.categoryIn {
  padding: 50px 0;
  background: #fff;
  height: 100%;
  position: relative;
}

.nav {
  position: fixed;
  top: 0;
  z-index: 2;
  // background: white;
  width: 100%;
  height: 45px;
  // box-shadow: 0 0 3px rgba(0, 0, 0, 0.137);

  .navInner {
    background: #ffffffc2;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    margin: 6px;
    border-radius: 7px;
    > img {
      width: 25px;
    }
    .mask-image {
      width: 25px;
      height: 25px;
      mask-image: url("~@/assets/img/left-arrow.svg");
    }
  }

  .title {
    padding-left: 8px;
  }
}

.wrapProductList {
  padding-bottom: 30px;
}

.wrapProductList::after {
  content: "";
  width: 100%;
  min-width: 140px;
  max-width: 240px;
}

.item {
  margin: 10px;
  display: flex;
  padding: 5px 10px;
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #d8d8d8;
  min-height: 60px;
}
</style>